import { useStoreon } from "storeon/react";
import { IReviewEvents, IReviewStore } from "../store/reviewSelectionStore";

export const useReviewStore = () => {
  const { reviewSelectionStore, dispatch: reviewSelectionDispatch } =
    useStoreon<IReviewStore, IReviewEvents>("reviewSelectionStore");

  return { reviewSelectionDispatch, reviewSelectionStore };
};
